<template>
    <b-modal ref="modal" :id="modalId" modal-class="modal-base" no-close-on-backdrop no-close-on-esc modal-header-close hide-header-close>
      <!-- Title Slot -->
      <template #modal-title>
        <span class="font-bold text-xl my-2">{{ title }}</span>
      </template>
  
      <!-- Body -->
      <p class="my-2">{{ bodyText }}</p>
  
      <!-- Footer Buttons -->
      <template #modal-footer>
        <div class="d-flex justify-content-end">
          <button
            v-if="showButton1"
            class="mob-btn mob-cta-gold rounded-lg mr-2"
            @click="onButton1Click"
          >
            {{ button1Text }}
          </button>
          <button
            v-if="showButton2"
            class="mob-btn mob-cta-gold-outline rounded-lg"
            @click="onButton2Click"
          >
            {{ button2Text }}
          </button>
        </div>
      </template>
    </b-modal>
  </template>
  
  <script>
  export default {
    name: 'MobBaseModal',
    props: {
      modalId: {
        type: String,
        default: 'base-modal'
      },
      title: {
        type: String,
        required: true
      },
      bodyText: {
        type: String,
        required: true
      },
      // Button visibility
      showButton1: {
        type: Boolean,
        default: true
      },
      showButton2: {
        type: Boolean,
        default: true
      },
      // Button texts
      button1Text: {
        type: String,
        default: 'Cerrar'
      },
      button2Text: {
        type: String,
        default: 'OK'
      },
      // Callbacks
      button1Callback: {
        type: Function,
        default: null
      },
      button2Callback: {
        type: Function,
        default: null
      }
    },
    methods: {
      onButton1Click() {
        if (this.button1Callback) {
            this.button1Callback();
        }

        this.closeModal();
      },
      onButton2Click() {
        if (this.button2Callback) {
            this.button2Callback();
        } 
      },
      closeModal() {
        this.$refs.modal.hide();
        this.$emit('closed');
      },
      showModal() {
        this.$refs.modal.show();
      }
    }
  };
  </script>

<style src="@/assets/css/bootstrap-modal.css"></style>
<style src="@/assets/css/bootstrap-custom.css" scoped></style>